module.exports = __webpack_public_path__ + "img/f-1.8ed55c2f.svg";